import { Color, Icon } from '@billy/design-system'
import React, { ReactElement } from 'react'

import * as Styled from './styles'

export const Checkmark = (): ReactElement => {
  return (
    <Styled.CheckmarkWrapper>
      <Icon icon="check" color={Color.Green400} />
    </Styled.CheckmarkWrapper>
  )
}
